<template>
    <div class="index">
        <div class="tip" v-if="detailData.auditStatus==20||detailData.auditStatus==50">
            <span>*</span>审核不通过原因:{{detailData.taskReason}}
        </div>
        <el-tabs type="border-card" @tab-click="changeTab">
            <el-tab-pane label="任务信息">
                <div class="section">
                    <div class="title">
                        基础信息
                    </div>
                    <div class="item">
                        <div class="label">
                            赔案号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cClmNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>

                    <div class="item">
                        <div class="label">
                            调查任务
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.cDoubtId" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查任务开始时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="detailData.startTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查任务截至时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="detailData.endTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调度人
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.dispatcher" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            作业人
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.operator" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            作业机构
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                </div>
                

               
                <div class="section">
                    <div class="title">
                        保险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            保障产品
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cProdName" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            保单号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cPlyNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            投保时间
                        </div>
                        <el-date-picker
                        v-model="surveyDataInfo.tInsAddTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                    <!-- <div class="item">
                        <div class="label">
                            与成员的关系
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.guanxi" size="small" placeholder="请选择" @change="bzProductIdChange" class="citem-input">
                                <el-option
                                v-for="item in relationList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="label">
                            被保人
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cInsuredNme" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            被保人证件类型
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.cCertType" size="small" placeholder="请选择" @change="bzProductIdChange" class="citem-input">
                                <el-option
                                v-for="item in InsuredNoTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                   
                    <div class="item">
                        <div class="label">
                            被保人证件号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cCertNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="title">
                        出险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            出险时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="surveyDataInfo.tAccdntTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div class="label">
                            出险地区
                        </div>
                        <div class="value">
                            <el-cascader
                            size="small"
                            :options="regionData"
                            v-model="surveyDataInfo.cAccdntPlace"
                            @change="handleRegionChange">
                            </el-cascader>
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="label">
                            出险地点
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cAccdntPlace" placeholder="请输入" size="small"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            出险经过
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cAccdntPro" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    
                </div>
                <div class="section">
                    <div class="title">
                        报案信息
                    </div>
                    <div class="item">
                        <div class="label">
                            报案人电话
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cRptTell" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                   
                    <div class="item">
                        <div class="label">
                            报案时间
                        </div>
                        <el-date-picker
                        v-model="surveyDataInfo.tRptTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                   
                </div>
               
                <div class="section">
                    <div class="title">
                        保司审核信息
                    </div>
                    <div class="item">
                        <div class="label">
                            保司审核状态
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.auditResult" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in auditResultList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                    <div class="item">
                        <div class="label">
                            保司不通过原因
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.backReason" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                </div>
                
                <div class="section">
                    <div class="title">
                        结案信息
                    </div>
                    <div class="item">
                        <div class="label">
                            赔付结论
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.claimResultStr" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            实际赔付金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.actualAmount" placeholder="请输入" size="small"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            减损金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.derogationAmount" placeholder="请输入" size="small"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            约定赔付金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.agreedAmount" placeholder="请输入" size="small"></el-input>
                        </div>
                    </div>
                    
                </div>
            </el-tab-pane>
            <el-tab-pane label="调查信息">
                <div style="margin:0 10px;width:100%">
                    <!-- <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="doubtCourseAddTip()">添加调查信息</el-button>
                        </div>
                    </div> -->
                    <el-table
                        :data="surveyData"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                       
                        <el-table-column
                        prop="cSvyNeed"
                        label="调查需求"
                        align="center"
                        width="400">
                        </el-table-column>
                        <el-table-column
                        prop="tHopeEndTm"
                        label="期望完成时间"
                        align="center"
                        width="240">
                        <template slot-scope="scope">
                            <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cSvyType"
                        label="疑似类型"
                        align="center"
                        width="150">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyMode"
                        label="案件类型"
                        align="center"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyPlace"
                        label="调查地点"
                        align="center"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="cSvyAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column>
                    
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="100px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="surveyDataDetail(scope.row)">查看详情</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="调查资料">
                <div style="margin:0 10px;width:100%">
                    
                    <!-- <el-table
                    :data="surveyInfo"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width:100%"
                    >
                    <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="materialType"
                    label="资料类型"
                    align="center"
                    width="180"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.materialType==1">图片</span>
                        <span v-if="scope.row.materialType==2">音频</span>
                        <span v-if="scope.row.materialType==3">音视频</span>
                        <span v-if="scope.row.materialType==4">其他</span>
                    </template>

                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="资料名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="180px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="small" @click="showImg(scope.row.path)" v-if="scope.row.materialType==1">点击查看</el-button>
                        <el-button type="text" icon="el-icon-download" size="mini" @click="download(scope.row.path,scope.row.name)">下载</el-button>
                    </template>
                    </el-table-column>
                    </el-table> -->
                    <div class="materiallist">
                        <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                            <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                            <el-image
                            style="width: 120px; height: 120px"
                            :src="item.path"
                            v-else
                            @click="showImg(item.path,surveyInfo)"
                            :fit="cover"></el-image>
                            <div class="filename">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="调查结果">
                <div class="section">
                    <div class="title">
                        调查要求
                    </div>
                    <div class="item">
                        <div class="value" style="width:590px">
                            <el-input v-model="detailData.dcyq" placeholder="请输入" size="small" type="textarea" rows="4" disabled></el-input>
                        </div>
                    </div>
                </div>
                
                <div class="section">
                    <div class="title">
                        调查过程
                    </div>
                    <div style="margin:0 10px;width:100%">
                        <!-- <div class="handle">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="doubtCourseAddTip()">添加调查节点</el-button>
                            </div>
                        </div> -->
                        <el-table
                        :data="detailData.doubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        prop="cCourAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column> -->
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                        
                        </el-table>
                    </div>
                </div>

                <div class="section">
                    <div class="title">
                        调查资料
                    </div>
                    <div style="margin:0 10px;width:100%">
                        <div class="section-item" v-for="(mitem,mindex) in materialList" :key="mindex">
                            <div class="stitle">{{mitem[0].name}}</div>
                            <div class="materiallist">
                                <div class="material" v-for="(item,index) in mitem" :key="index">
                                    <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                    <el-image
                                    style="width: 120px; height: 120px"
                                    :src="item.path"
                                    v-else
                                    @click="showImg(item.path,mitem)"
                                    :fit="cover"></el-image>
                                    <!-- <img src="../../../assets/images/icon08.png" class="close" @click="clearMaterial(mindex,index)" alt=""> -->
                                    <div class="filename">{{item.fileName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="section" v-if="detailData.isZhuPai">
                    <div class="title">
                        调查结论
                    </div>
                    <div class="item">
                        <div class="label">
                            调查结论
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.cConclusion" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in cConclusionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model="surveyDataInfo.cConclusion" placeholder="请输入" size="small" disabled></el-input> -->
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cConcRst" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                        <div class="label">
                            拒赔原因
                        </div>
                        <div class="value" style="width:590px">
                            
                            <el-select v-model="surveyDataInfo.cRefuseRsn" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in RefuseRsnList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                        <div class="label">
                            拒赔金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='2'">
                        <div class="label">
                            减损金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>


        
        <div class="btns" v-if="detailData.auditStatus==10">
            <el-button type="warning" icon="el-icon-edit" @click="isNoAudit=true">审核不通过</el-button>
            <el-button type="success" icon="el-icon-edit" @click="examineTask(30)">审核通过</el-button>
        </div>
        <div class="btns" v-if="detailData.auditStatus==40">
            <el-button type="warning" icon="el-icon-edit" @click="isNoAudit=true">审核不通过</el-button>
            <el-button type="success" icon="el-icon-edit" @click="examineTask(60)">审核通过</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDoubtCourse" title="添加" width="800px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div class="item">
                    <div class="label">
                        调查时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addDoubtCourse.tCourTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查省级市
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查项目
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourProList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in CCourModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人姓名
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人与被保人关系
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourRelaList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查过程
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="addDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-zoom-in" @click="addDoubtCourseF">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddCaseMaterial" title="添加资料" width="800px">
           
            <div class="item">
                <div class="label">
                    资料名称
                </div>
                <div class="value">
                    <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    单证资料
                </div>
                <div class="value">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadCPath"
                        >
                        <el-button icon="el-icon-upload2" type="primary" size="small">上传资料</el-button>
                    </el-upload>

                    <el-button type="primary" icon="el-icon-download" size="small" @click="download(addCaseMaterial.path,addCaseMaterial.name)" style="margin-left:20px" v-if="addCaseMaterial.path">下载</el-button>
                </div>
            </div>
               
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="addCaseMaterialF">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isNoAudit" title="审核不通过" width="800px">
           
            <div class="item">
                <div class="label">
                    不通过原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="taskReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="examineTask(20)">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="调查过程"
            :visible.sync="cProcessDetailDialog"
            width="600px"
            :modal="false"
            v-dialogDrag
            >
            <el-input
            placeholder="请输入内容"
            v-model="cProcess"
            type="textarea"
            :rows="20"
            >
            </el-input>
        </el-dialog>

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList ,CCourModeList ,RefuseRsnList} from "../../../assets/selectList/anxin";
import { parseTimeS } from "../../../utils/index";
 import "../../../utils/dialog"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
        // $route(to,from){
        //     if(from.name == 'audit'){
        //         this.queryDoubtTaskItemById();
        //     }
        // }
    },
    data () {
        return {
            uploadUrl:'',
            cCourPlaceList:cCourPlaceList,
            cCourProList:cCourProList,
            cCourRelaList:cCourRelaList,
            CCourModeList:CCourModeList,
            RefuseRsnList:RefuseRsnList,
            isAssignTask:false,
            detailData:{},
            isAddDoubtCourse:false,
            isAddCaseMaterial:false,
            addDoubtCourse:{},
            addCaseMaterial:{},
            options:regionData,
            selectedOptions:null,
            cConclusionList:[{
                label:'正常赔付',
                value:'1',
            },{
                label:'减损',
                value:'2',
            },{
                label:'拒赔',
                value:'3',
            }],
            isNoAudit:false,
            taskReason:'',

            cProcessDetailDialog:false,
            cProcess:'',
            addCaseMaterialList:[],
            materialList:[],

            surveyDataInfo:{
                anXinDcTaskId:'',
                cConclusion:null,
                cConcRst:'',
                cRefuseRsn:'',
                nRefusePayAmt:null,
                nDeroAmt:null,
            },
            showBigImg:false,
            showBigImgList:[],
            surveyInfo:[],
            surveyData:[],
            imgIndex:0,
        }
    },
    created(){
        

    },
    mounted(){
        this.queryDoubtTaskItemById();
    },
    methods:{
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 调查过程
        doubtCourseAddTip(){
            this.isAddDoubtCourse = true;
        },
        // 添加调查节点成功
        async addDoubtCourseF(){
            this.addDoubtCourse.tCourTm = parseTimeS(this.addDoubtCourse.tCourTm)

             
            console.log(this.addDoubtCourse);
            this.detailData.doubtCourseList.push({
                cCourAddr:this.addDoubtCourse.cCourAddr,
                cCourAll:this.addDoubtCourse.cCourAll,

                cCourMode:this.addDoubtCourse.cCourMode,
                cCourOperNme:this.addDoubtCourse.cCourOperNme,
                cCourPlace:this.addDoubtCourse.cCourPlace,
                cCourPro:this.addDoubtCourse.cCourPro,
                cCourRela:this.addDoubtCourse.cCourRela,
                cProcess:this.addDoubtCourse.cProcess,
                tCourTm:this.addDoubtCourse.tCourTm,
            });
            this.$forceUpdate(); 
            this.isAddDoubtCourse = false;
        },
        deleteCCourTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteCCour(index){
            this.detailData.doubtCourseList.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });    
        },
        // 调查任务Id查询调查信息
        async queryDoubtTaskItemById(){
            let res = await api.queryDoubtTaskItemById(this.$route.query.id);
            this.detailData = res.data.data;
            this.detailData.doubtCourseList = this.detailData.doubtCourseList?this.detailData.doubtCourseList:[]
            this.detailData.doubTaskMaterialItems = this.detailData.doubTaskMaterialItems?this.detailData.doubTaskMaterialItems:[]
            this.materialList = [];
            let name = '';
            for(let i in this.detailData.doubTaskMaterialItems){
                if(name!=this.detailData.doubTaskMaterialItems[i].name){
                    name = this.detailData.doubTaskMaterialItems[i].name;
                    this.materialList.push([]);
                }
                this.materialList[this.materialList.length-1].push(this.detailData.doubTaskMaterialItems[i]);
            }
            this.queryAnXinDcTaskByAnXinDcTaskId(this.detailData.anXinDcTaskId);
        },
        
        
        handleRegionChange(){
            console.log(this.selectedOptions);
            for(let index in this.selectedOptions){
                if(index==0){
                    this.addDoubtCourse.cCourAll =  this.selectedOptions[index]
                }else{
                    this.addDoubtCourse.cCourAll =  this.addDoubtCourse.cCourAll+'-'+this.selectedOptions[index]
                }
            }
        },
       
        // 下载资料
        download(path,name){
            
            const elt = document.createElement('a');
            elt.setAttribute('href', path);
            elt.setAttribute('target', '_blank');
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        audit(isAudit){
            if(isAudit){
                this.$confirm('再次确认是否通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.edit(true);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });          
                });
            }
        },
        async examineTask(auditStatus){
            let option = {
                id:this.$route.query.id,
                auditStatus:auditStatus,
                taskReason:this.taskReason
            };
            
            let res  = await api.updateAuditStatus(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.isNoAudit = false;
                this.queryDoubtTaskItemById();
            }
        },
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        // 添加资料
        addCaseMaterialF(){
            console.log(this.addCaseMaterial);
            this.detailData.doubTaskMaterialItems.push({
                fileType:this.addCaseMaterial.fileType,
                name:this.addCaseMaterial.name,
                path:this.addCaseMaterial.path,
            });
            this.isAddCaseMaterial = false;
            this.$forceUpdate();
        },
        

        async cProcessDetail(detail){
            console.log(detail);
            this.cProcess = detail;
            this.cProcessDetailDialog = true;
        },
        clearMaterial(i,j){
            this.materialList[i].splice(j,1);
        },

         // 查询调查信息
        async queryAnXinDcTaskByAnXinDcTaskId(){
            let res = await api.queryAnXinDcTaskByAnXinDcTaskId(this.detailData.anXinDcTaskId);
            console.log(res);
            this.surveyDataInfo=res.data.data
        },
        // 调查任务Id查询调查资料
        async queryAnXinCaseMaterialItemByAnXinDcTaskId(){
            let res = await api.queryAnXinCaseMaterialItemByAnXinDcTaskId(this.detailData.anXinDcTaskId);
            this.surveyInfo = res.data.data;
        },
        // 调查任务Id查询调查信息
        async queryAnXinDoubtDetailByAnXinDcTaskId(){
            let res = await api.queryAnXinDoubtDetailByAnXinDcTaskId(this.detailData.anXinDcTaskId);
            this.surveyData = res.data.data;
        },
        // 切换tab
        changeTab(e){
            if(e.index==0){
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
            if(e.index==1){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();
            }
            if(e.index==2){
                this.queryAnXinCaseMaterialItemByAnXinDcTaskId();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .index{
        background-color: #ffffff;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color:#606266;
    }
    .handle{
        margin-bottom: 10px;
    }
    .section{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
            }
            .value{
                width: 220px;
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
    
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .value{
            width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 20px 0;
    }
    .tip{
        padding: 10px;
        font-size: 14px;
        span{
            color: red;
            font-size: 14px;
            margin-right: 4px;
        }
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            height: 170px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
        }
        
    }
</style>
